











import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'

settings =
  name: 'DemographicsGenderDoughnutChart'

  vue:
    props: ['data']

    components: {
      BoxChart,
    }

    data: ->
      femaleChart: null
      maleChart: null

    methods:
      cleanUp: ->
        @femaleChart?.destroy()
        @maleChart?.destroy()

      draw: ->
        @femaleChart = @drawGenderChart({
          label: 'Female'
          context: @$refs.femaleChart
          color: ChartUtility.COLORS.pink
          value: @data.female
        })
        @maleChart = @drawGenderChart({
          label: 'Male'
          context: @$refs.maleChart
          color: ChartUtility.COLORS.blue
          value: @data.male
        })

      drawGenderChart: ({ context, label, color, value }) ->
        new Chart(context, {
          plugins: [DoughnutLabel]
          type: 'doughnut'
          data: {
            datasets: [{
              data: [value, 100 - value]
              backgroundColor: [color, ChartUtility.COLORS.grey]
            }]
          }
          options: {
            layout: {
              padding: 24
            }
            plugins: {
              legend: {
                display: false
              }
              tooltip: {
                enabled: false
              }
              doughnutlabel: {
                labels: [
                  {
                    text: value + '%'
                    color: color
                    font: {
                      size: 24
                      weight: 'bold'
                    }
                  }
                  {
                    text: label
                    color: ChartUtility.COLORS.slate
                    font: {
                      size: 13
                    }
                  }
                ]
              }
            }
          }
        })

export default VueOptions.vue settings
